export default __webpack_public_path__ + "static/media/Photograph_image.a65e3cfa.svg";